import { css } from '@emotion/react';
import { rgba } from 'emotion-rgba';

import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontRegular, getOtherIcons } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
import { flex } from 'src/styles/utils';

import { OtherIconsSet } from '../../utils/constants/IconsConstants';
export const fallbackWrapper = css`
  padding: 16px 0;
  ${MQ.MediaLg} {
    padding: 24px 0;
  }
`;
export const fallbackContent = css`
  padding: 100px 16px;
  background: ${colors.PrimaryWhiteColorAlpha10};
  margin: 0px 16px;
  border-radius: 6px;

  ${MQ.MediaMd} {
    padding: 150px 16px;
  }
  ${MQ.MediaLg} {
    padding: 150px 24px;
    margin: 0 7.5%;
  }
`;
export const defaultFallbackContainerStyle = css`
  ${flex('column', 'center', 'center')}
`;
export const defaultFallbackIconStyle = (
  ErrorIcon: OtherIconsSet,
  isAmaFallBack: boolean
) => css`
  ${ZeeFontRegular(50)}
  color: ${rgba(colors.white, 0.5)};
  border: 4px solid ${rgba(colors.white, 0.5)};
  padding: 30px;
  border-radius: 50%;
  margin-bottom: 24px;
  ${getOtherIcons(ErrorIcon, false)};
  ${isAmaFallBack && `color: ${colors.orange}; border-color:  ${colors.orange}`}
`;
export const defaultFallbackTitleStyle = css`
  ${ZeeFontBold(20, 30)}
  margin-bottom: 24px;
  text-align: center;
  color: ${colors.AmethystSmoke};
  ${MQ.MediaMd} {
    ${ZeeFontBold(32)}
  }
  ${MQ.MediaLg} {
    ${ZeeFontBold(55)}
  }
`;
export const defaultFallbackDescriptionStyle = css`
  ${ZeeFontRegular(15, 15)}
  cursor: pointer;
  color: ${colors.PurpleLight};
  text-decoration: underline;
  ${MQ.MediaMd} {
    ${ZeeFontRegular(20)}
  }
  ${MQ.MediaLg} {
    ${ZeeFontRegular(38)}
  }
`;

export const featureFallbackDescription = css`
  ${ZeeFontRegular(15, 15)}
  color: ${colors.AmethystSmoke};
  ${MQ.MediaMd} {
    ${ZeeFontRegular(20)}
  }
  ${MQ.MediaLg} {
    ${ZeeFontRegular(38)}
  }
`;

export const noInternetHeadingStyle = css`
  ${defaultFallbackTitleStyle};
  color: ${rgba(colors.AmethystSmoke, 0.5)};
  margin-bottom: 12px;
  text-align: center;
`;

export const noInternetDescriptionStyle = css`
  ${defaultFallbackDescriptionStyle};
  color: ${colors.TransparentSmoke};
  text-decoration: none;
  cursor: none;
  text-align: center;
`;
